import styled from 'styled-components'
import { Row } from '@shipt/design-system-layouts'
import { screenSizes } from '@shipt/design-system-themes'
import { routes } from '@shared/constants/routes'
import {
  MEMBERSHIP_POPOVER_LINKS,
  SAME_DAY_DELIVERY_LINKS,
} from '@/features/shared/constants/layouts'
import dynamic from 'next/dynamic'
import { ABOUT_US_LINKS, SHOP_LINKS } from '@/features/shared/constants/hyperlinks'
import { LinksPopover } from '@/features/shared/components/Headers/UngatedHeader/NavPopover/LinksPopover'

const CategoryPopover = dynamic(
  async () => (await import('./NavPopover/CategoryPopover')).CategoryPopover,
  { ssr: false },
)

export const UngatedHeaderLinks = () => {
  return (
    <NavLinkWrapper spacing="xl">
      <LinksPopover
        title="Same-day delivery"
        links={SAME_DAY_DELIVERY_LINKS}
        url={routes.DELIVERY.url}
      />
      <LinksPopover title="Shop" links={SHOP_LINKS} url={routes.GLOBAL_HOMEPAGE.url} />
      <CategoryPopover />
      <LinksPopover title="Memberships" links={MEMBERSHIP_POPOVER_LINKS} />
      <LinksPopover title="About us" links={ABOUT_US_LINKS} url={routes.ABOUT.url} />
    </NavLinkWrapper>
  )
}

const NavLinkWrapper = styled(Row)`
  display: none;

  @media ${screenSizes.smDesktop} {
    display: flex;
    align-items: center;
  }
`
